import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

export const StyledSearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(4),
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledSearchCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${theme.palette.other.outlineBorder}`,
  borderRadius: '8px',
  padding: theme.spacing(5, 5, 5, 5),
  width: '100%',
  justifyContent: 'center',
  boxShadow: `0px 59px 24px rgba(201, 201, 201, 0.02),
    0px 33px 20px rgba(201, 201, 201, 0.07),
    0px 15px 15px rgba(201, 201, 201, 0.12),
    0px 4px 8px rgba(201, 201, 201, 0.14),
    0px 0px 0px rgba(201, 201, 201, 0.14)`,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(5, 4, 5, 4),
    marginTop: theme.spacing(4),
  },
}));

export const StyledInfoOutlinedIcon = styled(InfoOutlined)(({ theme }) => ({
  color: theme.palette.action.active,
}));
